import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import config from "../../../config";
import ProductCard from "../productCard";
import ProductFilter from "../flters";
import { fetchProducts } from "../../../store/product.slice";
import ProductHeader from "../header";

const ProductGrid = ({ viewType, limit }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const { idCategory } = useParams();
  const pathName = window.location.pathname;
  const [categoryName, setCategoryName] = useState("");
  const dispatch = useDispatch();
  const allProducts = useSelector((state) => state.products.products);
  const isLoading = useSelector((state) => state.products.isLoading);
  const [categories, setCategories] = useState([]);
  const [hoveredCategory, setHoveredCategory] = useState(null);

  const handleMouseEnter = (id) => {
    setHoveredCategory(id);
  };

  const handleMouseLeave = () => {
    setHoveredCategory(null);
  };

  // État des filtres
  const [filters, setFilters] = useState({
    minPrice: 0,
    maxPrice: 0,
    categories: [],
    ratings: [],
    sortOrder: "",
  });

  const getCategories = async () => {
    try {
      const response = await axios.get(`${config.apiUrl}/all/category`);
      setCategories(response.data.data);
    } catch (error) {
      console.error(error);
    }
  };

  // Fonction pour mettre à jour les filtres
  const updateFilters = (newFilters) => {
    setFilters((prev) => ({ ...prev, ...newFilters }));
  };

  // Appliquer les filtres
  const applyFilters = () => {
    let updatedProducts = [...allProducts];
    let updatedCatProducts = [...filteredProducts];

    // Filtrer par catégorie si une catégorie est sélectionnée via l'URL
    if (idCategory) {
      handleConditionnalFilter(updatedCatProducts);
      // return;
    } else {
      handleConditionnalFilter(updatedProducts);
    }
  };

  const handleConditionnalFilter = (updatedCatProducts) => {
    if (filters.minPrice) {
      updatedCatProducts = updatedCatProducts.filter(
        (product) => Number(product.price) >= filters.minPrice
      );
    }
    if (filters.maxPrice) {
      updatedCatProducts = updatedCatProducts.filter(
        (product) => Number(product.price) <= filters.maxPrice
      );
    }

    // Filtrer par catégories sélectionnées
    if (filters.categories.length > 0) {
      updatedCatProducts = updatedCatProducts.filter((product) =>
        filters.categories.includes(product.category.id)
      );
    }

    // Filtrer par note
    if (filters.ratings.length > 0) {
      updatedCatProducts = updatedCatProducts.filter((product) =>
        filters.ratings.includes(Math.floor(product.rating))
      );
    }

    // Trier par ordre alphabétique si nécessaire
    if (filters.sortOrder === "atoz") {
      updatedCatProducts.sort((a, b) => a.name.localeCompare(b.name));
    } else if (filters.sortOrder === "ztoa") {
      updatedCatProducts.sort((a, b) => b.name.localeCompare(a.name));
    }

    // Limiter les produits si viewType est "trending"
    if (viewType === "trending" && limit) {
      updatedCatProducts = updatedCatProducts.slice(0, limit);
    }

    setFilteredProducts(updatedCatProducts);
  };

  // Fetch products on mount
  useEffect(() => {
    dispatch(fetchProducts());
  }, [dispatch]);

  useEffect(() => {
    applyFilters();
  }, [allProducts, filters, idCategory, viewType, limit]);

  // Fetch category-specific products when ID changes
  useEffect(() => {
    if (idCategory) {
      fetchCategoryProducts(atob(idCategory));
      getCategories();
    } else {
      // setFilteredProducts(allProducts);
      applyFilters();
    }
  }, [idCategory, allProducts]);

  // Fetch category products
  const fetchCategoryProducts = async (categoryId) => {
    try {
      const { data } = await axios.get(
        `${config.apiUrl}/one/categories/${categoryId}`
      );
      setFilteredProducts(data.data.products);
      setCategoryName(data.data.name);
      // applyFilters();
      console.log("Category products:", data);
    } catch (error) {
      console.error("Failed to fetch category products:", error);
    }
  };

  // Pagination logic
  const productsPerPage = 10;
  const idLastProduct = currentPage * productsPerPage;
  const idFirstProduct = idLastProduct - productsPerPage;
  const currentProducts = filteredProducts.slice(idFirstProduct, idLastProduct);
  // const numberOfPages = Math.ceil(filteredProducts.length / productsPerPage);

  // Déterminer si on est sur la vue marketplace principale
  const isMarketPlace = viewType === "trending";

  // Determine which products to display
  const productsToDisplay = isMarketPlace ? currentProducts : filteredProducts;

  const screenWidth = window.innerWidth;
  console.log("screen", screenWidth);

  // const setCategoryActive = () => {
  //   const idCategoryActive =
  // }  ${screenWidth > 1280 ? " px-10 " : "container"}

  return (
    <div
      className={`container content-space-b-1 content-space-b-lg-2 
       
      ${!isMarketPlace ? "content-space-t-3 content-space-t-lg-4" : ""}`}
      // style={{ paddingInline: "350px" }}
    >
      <div className="w-md-75 w-lg-50 text-center mx-md-auto mb-5 mb-md-9">
        {idCategory ? (
          <>
            <div className="mb-6 d-flex justify-content-center flex-wrap gap-2 align-items-center">
              {categories.map((category, idx) => (
                <span
                  onClick={() => fetchCategoryProducts(category.id)}
                  className={`border rounded-2 text-center p-2 ${
                    categoryName === category.name
                      ? "bg-secondary text-white fw-semibold"
                      : ""
                  } ${
                    hoveredCategory === category.id
                      ? " bg-secondary text-white fw-semibold"
                      : ""
                  }`}
                  key={category.id + "-" + idx}
                  style={{ cursor: "pointer" }}
                  onMouseEnter={() => handleMouseEnter(category.id)}
                  onMouseLeave={handleMouseLeave}
                >
                  {" "}
                  {category.name}{" "}
                </span>
              ))}
            </div>

            <h2>{`List of "${categoryName}"`} </h2>
          </>
        ) : viewType === "trending" ? (
          <h2>{"What's trending"}</h2>
        ) : (
          <h2>{"Products list"}</h2>
        )}
      </div>

      <div className="row align-items-start pt-3">
        {viewType === "all" && productsToDisplay.length !== 0 && (
          <ProductFilter
            filters={filters}
            updateFilters={updateFilters}
            categoryId={idCategory}
          />
        )}
        <div
          className={`${
            pathName === "/market-place" || productsToDisplay.length === 0
              ? "col-lg-12"
              : "col-lg-9 col-xxl-10"
          } row`}
          // className="row col-lg-9"
        >
          {/* Loader */}
          {isLoading ? (
            <div className="text-center w-100 content-space-t-3# d-flex justify-content-center align-items-center">
              <span className="spinner-border " role="status"></span>
              <span className="sr-only mx-2">Loading...</span>
            </div>
          ) : (
            <>
              {viewType === "all" && productsToDisplay.length !== 0 && (
                <ProductHeader
                  productLength={productsToDisplay.length}
                  handleAlphabeticOrder={(e) =>
                    setFilters((prev) => ({
                      ...prev,
                      sortOrder: e.target.value,
                    }))
                  }
                />
              )}
              {productsToDisplay.length > 0 ? (
                productsToDisplay.map((product, index) => (
                  <>
                    {product.is_visible !== 0 && Number(product.stock) > 0 && (
                      <ProductCard
                        key={index}
                        pathName={pathName}
                        product={product}
                      />
                    )}
                  </>
                ))
              ) : (
                <p className="content-space-t- fs-1 d-flex justify-content-center  ">
                  No products found
                </p>
              )}
            </>
          )}

          {viewType === "trending" && !isLoading && (
            <Link to="/market-place/products">
              <div className="text-center content-space-t-1 w-100">
                <button className="btn btn-primary rounded-pill text-center ">
                  View all products
                </button>
              </div>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductGrid;
